const _ = require('underscore');
const ProjectModel = require('common/domain/entity/project');
const ProjectCollection = require('common/domain/collection/project');
const Backbone = require('backbone');
const ProjectAPI = require('common/infra/api/project');

class Repository extends Backbone.Model{
    constructor(options) {
        super(options);

        this._fetched = {};
        this._projects = new ProjectCollection();
    }

    getProjects() {
        return this._projects;
    }

    fetch(projectID) {
        return ProjectAPI.getProject(projectID).then(projectJSON => {
            const project = new ProjectModel(projectJSON);
            this._projects.add(project, { merge: true });
            return project;
        });
    }

    fetchOnce(projectID) {
        const project = this._projects.get(projectID);
        if (project) {
            return new Promise(resolve => {
                resolve(project);
            });
        }

        let promise = this._fetched[projectID];
        if (!promise) {
            promise = this.fetch(projectID);
            this._fetched[projectID] = promise;
        }
        return promise;
    }

    // deprecated: fetchOnce(projectID) を使ってください
    getProject(projectID) {
        return this.fetchOnce(projectID);
    }

    add(project) {
        this._projects.add(project, { merge: true });
    }

    remove(project) {
        this._projects.remove(project);
    }
}

module.exports = new Repository();



// WEBPACK FOOTER //
// ./common/domain/repository/project.js